import React from 'react';

// The mkg integration has no settings to fill in, the activation
// happens directly from the page actions so this form renders nothing
const MkgIntegrationForm: React.FC<{ viewKey?: string }> = () => null;

export default MkgIntegrationForm;
